<style lang="less" scoped>
.center{position: absolute; top: 0;bottom: 0; left: 0; right: 0;}
.btnary{position: absolute;bottom: 0;width: 100%; background: rgba(0,0,0,.2);display: flex;justify-content: space-between;}
.btn_left{width: 20%;height: 80px;margin: 0;padding: 0;display: flex;align-items: center;}
.btn_right{width:30%;height:80px;margin: 0;padding: 0;display: flex;align-items: center;justify-content: flex-end;}
li{display: flex;flex-direction: column;margin: 0 10px;height: 70px;cursor: pointer;}
span{width: 40px;height: 40px;display: inline-block;line-height: 40px;border-radius: 50% 50%;text-align: center;background: rgba(160,159,160,.4);margin: auto;
  i{color: #FAFAFA;font-size: 25px;}
}
small{color: #FAFAFA;}
#ZTmod{width: 100%;height: 100%;}
#instructions {background-color: rgba(0,0,0,0.5);width: 100%;height: 100%;cursor: pointer;position: absolute;
   p{height: 250px;width:100%; position: absolute; top: 30%; margin: auto;line-height: 250px; font-size: 60px;color: #ccc;font-family: STFangsong;}
 }
.text{position: absolute;left: 0;right: 0;top: 90px;}
.icon{background:url('../../../../static/index/loading.gif') no-repeat;background-size: 100%;margin: auto;}
.dblclick{display: none;}
</style>

<template>
  <div class="center">
    <ScaleBox>
    <div id="ZTmod">
      <div id="instructions">
        <p class="loading">
          <span>Click to play</span>
          <i style="display:block; width:300px; height:200px" class="icon"></i>
          <i class="text">加载中......</i>
        </p>
        <p class="dblclick">Double click play</p>
      </div>
    </div>
    <div>
      <audio id="cheerMusic" ref="music" preload="auto" loop="loop" src="static/告白之夜.mp3"></audio>
    </div>
    <div class="btnary">
      <ul class="btn_left">
        <li>
          <span><i class="iconfont icon-leimupinleifenleileibie"></i></span>
          <small>场景选择</small>
        </li>
        <li>
          <span><i class="iconfont icon-daohang-tuiguanglianjie"></i></span>
          <small>场景分享</small>
        </li>
      </ul>
      <ul class="btn_right">
        <li @click="musicPlaying">
          <span><i :class="flag?music1:music2"></i></span>
          <small>音乐</small>
        </li>
        <li>
          <span><i class="iconfont icon-2"></i></span>
          <small>全景简介</small>
        </li>
        <li>
          <span><i class="iconfont icon-xuanzhuan"></i></span>
          <small>自动旋转</small>
        </li>
        <li>
          <span><i class="iconfont icon-dianzan"></i></span>
          <small>1</small>
        </li>
      </ul>
    </div>
   </ScaleBox>
  </div>
</template>

<script>
import { PointerLockControls } from 'three/examples/jsm/controls/PointerLockControls.js'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js'   //引入控制器
/* eslint-disable */
import ScaleBox from '../assembly/ScaleBox.vue'
// import inflate from 'three/examples/js/libs/inflate.min.js'
// import {FBXLoader} from 'three/examples/js/loaders/FBXLoader.js'

export default {
  components: {ScaleBox},
  name: '',
  data()
  {
    return {
      music1: 'iconfont icon-yinyue',
      music2: 'iconfont icon-jingyin1',
      flag: true,
      num: 1,
      renderer: '',
      scene: '',
      camera: '',
      mixer: null,
      action: null,
      clock1: new THREE.Clock(),
      controls: null,
      //按键方向
      moveForward: false,
      moveLeft: false,
      moveBackward: false,
      moveRightInit: false,
      direction: new THREE.Vector3(),
      velocity: new THREE.Vector3(),
      prevTime: performance.now()
    }
  },
  computed: {
  },
  // watch: {
  //   $route: {
  //     handler(nval, oval)
  //     {
  //       this.loadObj(nval.params.name)
  //     },
  //     immediate: true
  //   }
  // },
  created()
  {
    // this.$nextTick(() =>
    // {
    //   this.initRender('ZTmod')
    //   this.initCamera()
    //   this.initScene()
    //   this.initLight()
    //   this.loadObj(this.$route.params.name)
    //   this.initControls()//相机视角
    //   this.render()//渲染
    //   // //轨道控制器
    //   // this.createControls()
    //   // this.animate()
    // })
    //监听浏览器窗口变化
    window.addEventListener("resize",function()
    {
      camera.aspect = window.innerWidth / window.innerHeight
      camera.updateProjectionMatrix()
      this.renderer.setSize( window.innerWidth, window.innerHeight ) 
    })
  },
  methods:
  {
    musicPlaying()
    {
      this.flag = !this.flag
      if (this.flag)
        this.audioAutoPlay()
      else
        this.musicPlay()
    },
    musicPlay()
    {
      let music = document.getElementById('cheerMusic')
      music.pause()
    },
    /* 自动播放音乐 */
    audioAutoPlay()
    {
      let music = document.getElementById('cheerMusic')
      music.play()
      let play = function()
      {
        music.play()
        document.removeEventListener('touchstart', play, false)
      }
      music.play()
      document.addEventListener('WeixinJSBridgeReady', function()
      {
        play()
      }, false)
      document.addEventListener('YixinJSBridgeReady', function()
      {
        play()
      }, false)
      document.addEventListener('touchstart', play, false)
    },

    initRender(containerid)
    {
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      document.getElementById(containerid).appendChild(this.renderer.domElement)
      window.renderer = this.renderer
    },
    initCamera()
    {
      this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 2000)
      this.camera.position.set(5, 0, 0)
      window.camera = this.camera
    },
    initScene()
    {
      this.scene = new THREE.Scene()
      this.scene.background = new THREE.Color(0xcccccc)

      window.gModel = this.scene
    },
    // animate()
    // {
    //   this.renderer.render(this.scene, this.camera)
    //   this.controls.update()
    //   // 更新性能插件
    //   requestAnimationFrame(this.animate)
    // },
    initLight()
    {
      //半球光
      let hemiLight = new THREE.HemisphereLight(0xFFFFF0, 0xFFFFF0, 0.48)
      hemiLight.position.set(1, 1, 1)
      this.scene.add(hemiLight)
      //直射光-仿太阳光
      let dirLight = new THREE.DirectionalLight(0xFAFAFA, 0.16)
      dirLight.position.set(1, 1, 1)
      this.scene.add(dirLight)
      //环境光-调整饱和度
      let ambLight = new THREE.AmbientLight(0xFCFCFC, 0.37)
      this.scene.add(ambLight)
    },
    loadObj(name)
    {
      let self = this
      let loader = new FBXLoader()
      loader.load(`static/model/ZT5.FBX`, function (obj)
      {
        //模型载入后关闭提示
        let loading = document.querySelector('.loading')
        let dblclick = document.querySelector('.dblclick')
        if (obj)
        {
          loading.style.display = 'none'
          dblclick.style.display = 'block'
        }
        //计算模型外包盒
        let bbox = new THREE.Box3()
        bbox.setFromObject(obj)
        //计算包围盒长宽高
        let mdlen = bbox.max.x - bbox.min.x
        let mdwid = bbox.max.z - bbox.min.z
        let mdhei = bbox.max.y - bbox.min.y
        //计算外包盒中心坐标
        let x1 = bbox.min.x + mdlen / 2
        let y1 = bbox.min.y + mdhei / 2
        let z1 = bbox.min.z + mdwid / 2
        obj.position.set(-x1, -y1, -z1)
        self.scene.add(obj)   //将载入的obj模型添加到场景中
      })
    },
    // 创建控件对象
    createControls () {
      this.controls = new OrbitControls(this.camera,this.renderer.domElement)
      //修改鼠标按键
      this.controls.mouseButtons={
        LEFT:THREE.MOUSE.PAN,
        MIDDLE:THREE.MOUSE.DOLLY,
        RIGHT:THREE.MOUSE.ROTATE
      }
      //限制垂直旋转角度
      this.controls.maxPolarAngle = Math.PI / 2
      this.controls.minPolarAngle = Math.PI / 2
      this.controls.enableZoom = false
    },
    //鼠标控制移动相机视角
    initControls()
    {
      let that = this
      //移动
      let onKeyDown = function(event)
      {
        switch (event.keyCode)
        {
        case 38: // up
        case 87: // w
          that.moveForward = true
          break
        case 37: // left
        case 65: // a
          that.moveLeft = true
          break
        case 40: // down
        case 83: // s
          that.moveBackward = true
          break
        case 39: // right
        case 68: // d
          that.moveRightInit = true
          break
        }
      }
      let onKeyUp = function(event)
      {
        switch (event.keyCode)
        {
        case 38: // up
        case 87: // w
          that.moveForward = false
          break
        case 37: // left
        case 65: // a
          that.moveLeft = false
          break
        case 40: // down
        case 83: // s
          that.moveBackward = false
          break
        case 39: // right
        case 68: // d
          that.moveRightInit = false
          break
        }
      }
      that.controls = new PointerLockControls(this.camera, document.body)
      let container = document.getElementById('ZTmod')
      let instructions = document.getElementById('instructions')
      container.addEventListener('dblclick', function()
      {
        that.controls.lock()
        //背景音乐插件
        if (that.num === 1)
          that.audioAutoPlay()
        that.num++
      })
      //鼠标被捕获时
      that.controls.addEventListener('lock', function()
      {
        instructions.style.display = 'none'
        //添加键盘事件监听
        document.addEventListener('keydown', onKeyDown, false)
        document.addEventListener('keyup', onKeyUp, false)
      })
      //鼠标不再被捕获时
      that.controls.addEventListener( 'unlock', function()
      {
        //解除键盘事件监听
        document.removeEventListener('keydown', onKeyDown, false)
        document.removeEventListener('keyup', onKeyUp, false)
      })
      // //设置初始视角的位置
      // that.controls.getObject().position.y = 0
      // that.controls.getObject().position.x = 0
      // that.controls.getObject().position.z = 0
    },
    render()
    {
      let that = this
      requestAnimationFrame(that.render) //请求再次执行渲染函数render
      that.renderer.render(that.scene, that.camera)//执行渲染操作
      //从这开始下面**就是控制移动的代码
      let time = performance.now()
      let delta = (time - that.prevTime) / 1000
      that.velocity.x -= that.velocity.x * 20.0 * delta
      that.velocity.z -= that.velocity.z * 20.0 * delta
      that.direction.z = Number(that.moveForward) - Number(that.moveBackward)
      that.direction.x = Number(that.moveRightInit) - Number(that.moveLeft)
      that.velocity.z -= that.direction.z * 80.0 * delta
      that.velocity.x -= that.direction.x * 80.0 * delta
      //下面两个&&是判断是否有moveRight。如果有就执行。不然没加载完毕，就循环执行会报错
      that.controls && that.controls.moveRight(-that.velocity.x * delta)
      that.controls && that.controls.moveForward(-that.velocity.z * delta)
      that.prevTime = time
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/project/FictitiousZT.vue